import { SiteStatus } from "@anu-its/cat-grpc-pb/js/anu/cat/enums_pb";
import { Button } from "@anu-its/ts-react-components";
import React from "react";
import { env } from "@/app/env";

export const CanvasLink = ({
  siteId,
  status,
  isIconOnly = false,
}: {
  siteId: string;
  status: SiteStatus;
  isIconOnly?: boolean;
}) => {
  if (status == SiteStatus.PROVISIONED || status == SiteStatus.PUBLISHED) {
    return (
      <Button
        classNames={`${isIconOnly ? "!border-none" : ""}`}
        size="small"
        variant="tertiary"
        href={`${env.NEXT_PUBLIC_CANVAS_BASE_URL}/courses/sis_course_id:${siteId}`}
        target="_blank"
        rel="noopener noreferrer"
        aria-label="View site details on Canvas LMS"
      >
        {isIconOnly ? (
          <IconCanvas />
        ) : (
          <div className="flex flex-row items-center">
            View in Canvas
            <div className="ml-2">
              <IconCanvas />
            </div>
          </div>
        )}
      </Button>
    );
  }

  return <></>;
};

const IconCanvas = ({ color = "#e72429" }: { color?: string }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 127.17 127.21"
    width="1.3em"
    height="1.3em"
  >
    <g id="Layer_2" data-name="Layer 2">
      <g id="Layer_1-2" data-name="Layer 1">
        <path
          className="cls-1"
          style={{ fill: color }}
          d="M18.45,63.47A18.4,18.4,0,0,0,2.31,45.23a73.13,73.13,0,0,0,0,36.47A18.38,18.38,0,0,0,18.45,63.47"
        />
        <path
          className="cls-1"
          style={{ fill: color }}
          d="M29.13,57.7a5.77,5.77,0,1,0,5.77,5.77,5.77,5.77,0,0,0-5.77-5.77"
        />
        <path
          className="cls-1"
          style={{ fill: color }}
          d="M108.72,63.47A18.38,18.38,0,0,0,124.86,81.7a73.13,73.13,0,0,0,0-36.47,18.4,18.4,0,0,0-16.14,18.24"
        />
        <path
          className="cls-1"
          style={{ fill: color }}
          d="M98,57.7a5.77,5.77,0,1,0,5.76,5.77A5.77,5.77,0,0,0,98,57.7"
        />
        <path
          className="cls-1"
          style={{ fill: color }}
          d="M63.46,108.77A18.39,18.39,0,0,0,45.23,124.9a73.13,73.13,0,0,0,36.47,0,18.38,18.38,0,0,0-18.24-16.13"
        />
        <path
          className="cls-1"
          style={{ fill: color }}
          d="M63.47,92.31a5.77,5.77,0,1,0,5.76,5.77,5.77,5.77,0,0,0-5.76-5.77"
        />
        <path
          className="cls-1"
          style={{ fill: color }}
          d="M63.47,18.44A18.37,18.37,0,0,0,81.7,2.31a73.13,73.13,0,0,0-36.47,0A18.39,18.39,0,0,0,63.47,18.44"
        />
        <path
          className="cls-1"
          style={{ fill: color }}
          d="M63.47,23.37a5.77,5.77,0,1,0,5.76,5.76,5.76,5.76,0,0,0-5.76-5.76"
        />
        <path
          className="cls-1"
          style={{ fill: color }}
          d="M95.44,95.44a18.4,18.4,0,0,0-1.5,24.29,73,73,0,0,0,25.78-25.79,18.39,18.39,0,0,0-24.28,1.5"
        />
        <path
          className="cls-1"
          style={{ fill: color }}
          d="M83.8,83.8a5.77,5.77,0,1,0,8.16,0,5.78,5.78,0,0,0-8.16,0"
        />
        <path
          className="cls-1"
          style={{ fill: color }}
          d="M31.59,31.59a18.36,18.36,0,0,0,1.5-24.28A72.93,72.93,0,0,0,7.31,33.09a18.36,18.36,0,0,0,24.28-1.5"
        />
        <path
          className="cls-1"
          style={{ fill: color }}
          d="M35.07,35.08a5.77,5.77,0,1,0,8.16,0,5.78,5.78,0,0,0-8.16,0"
        />
        <path
          className="cls-1"
          style={{ fill: color }}
          d="M95.4,31.53A18.39,18.39,0,0,0,119.69,33,72.88,72.88,0,0,0,93.9,7.25a18.39,18.39,0,0,0,1.5,24.28"
        />
        <path
          className="cls-1"
          style={{ fill: color }}
          d="M91.92,43.17a5.76,5.76,0,1,0-8.15,0,5.76,5.76,0,0,0,8.15,0"
        />
        <path
          className="cls-1"
          style={{ fill: color }}
          d="M31.56,95.37a18.39,18.39,0,0,0-24.28-1.5,73,73,0,0,0,25.78,25.79,18.38,18.38,0,0,0-1.5-24.29"
        />
        <path
          className="cls-1"
          style={{ fill: color }}
          d="M35,83.73a5.77,5.77,0,1,0,8.16,0,5.79,5.79,0,0,0-8.16,0"
        />
      </g>
    </g>
  </svg>
);
